class Swatches extends HTMLElement {
  constructor() {
    super();
    
    this.attachShadow({ mode: 'open' });
    this.storefrontAccessToken = 'cdc3337a74a0240221c52fdaa12f6de0';
    this.shopifyEndpoint = 'https://the-bigdog.myshopify.com/api/2023-01/graphql.json';

    this.shadowRoot.innerHTML = `
      <style>
        .swatches {
          display: flex;
          column-gap: 10px;
          flex-wrap: nowrap;
        }
        .swatches a {
            width: 38px;
            height: 38px;
            overflow: hidden;
            border-radius: 100%;
            flex-shrink: 0;
            border: 0;
            transition: border 0.3s ease;
            position: relative;
            outline: 1px solid #000;
            outline-offset: 2px;
        }

        @media (max-width: 767px) {
          .swatches a {
              width: 33px;
              height: 33px;
          }
        }

        .swatches a.active,
        .swatches a:hover{
          border-color: #b1b1b1;
          outline: 2px solid #000;
        }
        
        .swatches img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          right: 0;
        }

        .product-item .scroller {
            overflow: hidden;
        }

        .product-item .scroller__inner {
          padding-bottom: 23px;
          padding-top: 3px;
          margin-bottom: -19px;
          padding-left: 4px;
          margin-top: 3px;
          overflow-x: auto;
          overflow-y: visible;
          -webkit-overflow-scrolling: touch;
          -ms-scroll-snap-type: x mandatory;
          scroll-snap-type: x mandatory;
          white-space: nowrap;
        }
      </style>
      <div class="scroller"><div class="scroller__inner"><div class="swatches"></div></div></div>
    `;
  }

  connectedCallback() {
    // When the custom element is inserted into the DOM
    const productName = this.getAttribute('product-title');
    const productHandle = this.getAttribute('product-handle');
    this.clsvensty = this.getAttribute('data-clsvensty');
    
    this.fetchRelatedProducts(productName, productHandle);
  }
  
  replaceLastSegmentOfUrl(color) {
    const baseURL = window.location.origin;
    const filePath = "/cdn/shop/files/your_uploaded_file.jpg";
    const tempFileUrl = baseURL + filePath;
    
    const urlWithoutLastSegment = tempFileUrl.substring(0, tempFileUrl.lastIndexOf('/'));
    const newUrl = urlWithoutLastSegment + '/' + color;

    return newUrl
  }
  
  replaceSpaceWithUnderscore(color) {
    return color.replace(/ /g, "_")
  }

  fetchRelatedProducts(productName, productHandle) {
    const query = `
    {
      products(first: 50, query: "title:${productName.includes("'") ? `${productName}` : `'${productName}'`}") {
        edges {
          node {
            handle
            availableForSale
            images(first: 1) {
              edges {
                node {
                  url(transform:{maxHeight:120})
                }
              }
            }
            metafield(key: "ip_ids", namespace: "twc") {
              value
            }
          }
        }
      }
    }
    `;

    fetch(this.shopifyEndpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/graphql',
            'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken
        },
        body: query
    })
    .then(response => response.json())
    .then(data => {
      console.log(productHandle,data);
        this.renderProducts(data, productHandle);
    })
    .catch(error => console.error('Error fetching products:', error));
  }

  renderProducts(data, productHandle) {
    const productsContainer = this.shadowRoot.querySelector('.swatches');
    productsContainer.innerHTML = '';
    console.log(productHandle,data.data.products.edges);

    const products = data.data.products.edges.filter(product => {
      const metafield = JSON.parse(product.node.metafield.value);

      return metafield.clsvensty === this.clsvensty;
    });

    console.log(productHandle,products);
    
    products.forEach(product => {
        let althtml = '';
        const hndl = product.node.handle;
        const imgs = product.node.images.edges;

        // Assuming 'metafield' was supposed to be fetched, check its existence
        const meta = product.node.metafield;
        const available = product.node.availableForSale;

        if (!available) return;

        const unavailableClass = available ? '' : 'disabled';
        const activeClass = productHandle === hndl ? 'active' : '';

        if (imgs.length === 0 || meta === null) return;

        let metaJson;
        try {
            metaJson = JSON.parse(meta.value);
        } catch (e) {
            console.error("Failed to parse meta:", e);
            return;
        }

        if (!metaJson.color) return;

        althtml += `<a part="a" class="${activeClass}" href="/products/${hndl}"><img src="${this.replaceLastSegmentOfUrl(this.replaceSpaceWithUnderscore(metaJson.color))}.png" title="${metaJson.color}" /></a>`;

        // Convert the string to a DOM element and append to the shadow root
        const template = document.createElement('template');
        template.innerHTML = althtml.trim();
        productsContainer.appendChild(template.content.cloneNode(true));
    });
  }
}

customElements.define('swatches-element', Swatches);